import { House, PawPrint, Users, ShoppingBag } from "lucide-react";

// Reusable premium icon system for HomeHealthy.
// One visual language: outline icons, uniform stroke, neutral container.
const ICONS = {
  hogar: House,
  mascotas: PawPrint,
  acompanamiento: Users,
  recados: ShoppingBag,
};

export const PremiumIcon = ({ category, size = 26, active = false, hoverGroup = true, className = "" }) => {
  const Icon = ICONS[category] || House;
  const base = "inline-flex items-center justify-center w-12 h-12 rounded-2xl border transition-colors duration-300";
  const state = active
    ? "bg-forest text-white border-forest"
    : `bg-cream-deep text-ink border-line ${hoverGroup ? "group-hover:bg-forest group-hover:text-white" : ""}`;
  return (
    <span className={`${base} ${state} ${className}`} aria-hidden="true">
      <Icon size={size} strokeWidth={1.5} />
    </span>
  );
};
